import Nullstack from 'nullstack';
export default function IconDeviceGamepad({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-device-gamepad",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("rect", {
    x: "2",
    y: "6",
    width: "20",
    height: "12",
    rx: "2"
  }), "   ", Nullstack.element("path", {
    d: "M6 12h4m-2 -2v4"
  }), "   ", Nullstack.element("line", {
    x1: "15",
    y1: "11",
    x2: "15",
    y2: "11.01"
  }), "   ", Nullstack.element("line", {
    x1: "18",
    y1: "13",
    x2: "18",
    y2: "13.01"
  }), " ");
}